module.exports = __webpack_public_path__ + "img/刘志伟.bb661a28.jpg";